import Swiper from 'swiper';

$(function() {
    var mySwiper = new Swiper ('.swiper-cars', {
        slidesPerView: 1,
        freeMode: true,
        spaceBetween: 8,
        navigation: {
            nextEl: '.swiper-button-next-cars',
            prevEl: '.swiper-button-prev-cars',
        },
        breakpoints: {
            540: {
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 16,
              freeMode: false,

            },
            1280: {
              slidesPerView: 4,
              spaceBetween: 29,
            },
        }
    });
});
